import React, { useEffect } from "react";
import SectionHeader from "@/components/common/SectionHeader";
import { CheckCircle2 } from "lucide-react";

const STEPS = [
  "Understand buyer requirements",
  "Identify suitable supply partners",
  "Match product specifications",
  "Arrange samples where required",
  "Coordinate quality checks",
  "Confirm packaging and documentation",
  "Coordinate dispatch and shipment",
];

const CREDENTIALS = [
  { name: "IEC", note: "Importer Exporter Code — to be added by business owner" },
  { name: "GST", note: "Goods & Services Tax registration — placeholder" },
  { name: "APEDA", note: "Agricultural & Processed Food Products Export Development Authority — placeholder" },
  { name: "FSSAI", note: "Food Safety & Standards Authority of India — placeholder" },
  { name: "Certificate of Analysis", note: "Coordinated per shipment as required" },
  { name: "Phytosanitary Documentation", note: "Coordinated per shipment as required" },
];

export default function QualityPage() {
  useEffect(() => { document.title = "Quality & Compliance — Aaha Kanakam Traders"; }, []);
  return (
    <div data-testid="quality-page">
      <section className="bg-forest text-white py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
          <div className="eyebrow text-gold mb-3">Quality & Compliance</div>
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-tight max-w-3xl">Specification-driven. Documentation-ready.</h1>
          <p className="mt-5 max-w-2xl text-white/70">Our approach is buyer-first: understand the brief, source correctly, verify against specifications, and ship with the right documentation.</p>
        </div>
      </section>

      <section className="py-20 md:py-24 bg-ivory">
        <div className="max-w-6xl mx-auto px-4 sm:px-8 lg:px-12">
          <SectionHeader eyebrow="Our Process" title="A 7-step quality-focused workflow" />
          <ol className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {STEPS.map((s, i) => (
              <li key={s} data-testid={`process-step-${i + 1}`} className="p-6 bg-white border border-borderSubtle card-hover">
                <div className="font-serif text-4xl text-gold-600 mb-2">0{i + 1}</div>
                <div className="text-forest font-semibold text-base">{s}</div>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="py-20 md:py-24 bg-surface">
        <div className="max-w-6xl mx-auto px-4 sm:px-8 lg:px-12">
          <SectionHeader
            eyebrow="Documentation & Credentials"
            title="Editable placeholders — no fake claims"
            description="This section lists the standard documentation buyers may request. Registration numbers and certifications will be populated by the business owner as they are secured."
          />
          <div className="grid sm:grid-cols-2 gap-4">
            {CREDENTIALS.map((c) => (
              <div key={c.name} className="p-5 bg-white border border-borderSubtle flex items-start gap-4">
                <CheckCircle2 className="text-gold-600 shrink-0 mt-0.5" size={20} />
                <div>
                  <div className="font-serif text-lg text-forest">{c.name}</div>
                  <div className="text-xs text-slateneutral mt-1">{c.note}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
